export default "__VITE_ASSET__4M4gPItA__"